<app-access-helps-hero></app-access-helps-hero>

<section role="region" class="wrapper--bg">
  <div class="access-helps-video">
    <h2 class="access-helps-video__title">
      <span class="line-break">Toutes vos aides sont maintenant à portée de clic&nbsp;!</span>
      <span class="highlight--emphasis">Découvrez comment faire en regardant la vidéo ci-dessous</span>
    </h2>

    <div class="access-helps-video__embed">
      <button
        *ngIf="(playVideo$ | async) === false"
        class="access-helps-video__embed__play btn-clean"
        aria-label="Jouer la vidéo"
        type="button"
        (click)="toggleVideo()"
      >
        <mat-icon svgIcon="play" role="presentation"></mat-icon>
      </button>

      <picture *ngIf="(playVideo$ | async) === false">
        <source srcset="/assets/images/access-helps/thumbnail.webp" type="image/webp" />
        <source srcset="/assets/images/access-helps/thumbnail.jpg" />
        <img
          class="access-helps-video__embed__thumbnail"
          src="/assets/images/access-helps/thumbnail.jpg"
          alt=""
          loading="lazy"
        />
      </picture>
      <iframe
        *ngIf="(playVideo$ | async) === true"
        title="Simulateur d'aides 1 jeune 1 solution - Trouvez toutes vos aides en moins de 5 minutes"
        [src]="src"
      ></iframe>
    </div>
  </div>
</section>
